import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import toast from 'react-hot-toast';
import {toastService} from "../../utils/toastService"


function AddFacilitation(props) {
  const {
    handleSubmit,
    fields,
    errors,
    show,
    onHideFunc,
    values,
    isUpdate,
    id,
  } = props;

  const [data, setData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
const [showToast, setShowToast] = useState(false);
const [toastMessage, setToastMessage] = useState("");
const [toastVariant, setToastVariant] = useState("success"); // 'success' or 'danger'

  useEffect(() => {
    if (!show) {
      setData({});
      setValidationErrors({});
    }
  }, [show]);

  const countWords = (text) => {
    if (!text) return 0;
    return text.trim().split(/\s+/).filter(word => word.length > 0).length;
  };

  const validateField = (field, value) => {
    const fieldConfig = fields[field];
    const errors = {};

    // Required validation
    if (fieldConfig.required && (!value || value.trim() === "")) {
      errors[field] = `${fieldConfig.label} is required`;
      return errors;
    }

    // Word count validation
    if (fieldConfig.maxWords && value) {
      const wordCount = countWords(value);
      if (wordCount > fieldConfig.maxWords) {
        errors[field] = `${fieldConfig.label} must not exceed ${fieldConfig.maxWords} words (current: ${wordCount})`;
        return errors;
      }
    }

    return errors;
  };

  const handleChange = (e, field) => {
    const fieldData = { ...data };
    fieldData[field] = e.target.value;
    setData(fieldData);

    // Real-time validation
    const fieldErrors = validateField(field, e.target.value);
    setValidationErrors(prev => ({
      ...prev,
      [field]: fieldErrors[field] || null
    }));
  };

  const validateForm = () => {
    const allErrors = {};
    let isValid = true;

    Object.keys(fields).forEach(field => {
      const fieldErrors = validateField(field, data[field] || values[field] || "");
      if (fieldErrors[field]) {
        allErrors[field] = fieldErrors[field];
        isValid = false;
      }
    });

    setValidationErrors(allErrors);
    return isValid;
  };

 const handleFormSubmit = (e) => {
  e.preventDefault();

  if (validateForm()) {
    try {
      if (handleSubmit) {
        handleSubmit(e, isUpdate, id);
      }
    } catch (error) {
      toast.error("An unexpected error occurred.");
    }
  } else {
    toastService.error("Please fill out all required fields correctly.");
  }
};



  const getFieldError = (field) => {
    return validationErrors[field] || errors[field];
  };

  const getWordCount = (field) => {
    const value = data[field] || values[field] || "";
    return countWords(value);
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHideFunc}
      backdrop="static"
      className="border-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {!isUpdate ? "Create New Facilitation" : "Update Facilitation"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="grid-example">
        <div style={{ minHeight: "100px" }}>
          <div className="sign-user_card">
            <Form className="login-content" onSubmit={handleFormSubmit}>
              <div className="row">
                {!!fields &&
                  Object.keys(fields).map((field) => (
                    <div className="col-lg-12" key={field}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          {fields[field]["label"]}
                          {fields[field]["required"] && (
                            <span className="text-danger ms-1">*</span>
                          )}
                        </Form.Label>
                        
                        {fields[field]["type"] === "text" && (
                          <>
                            <Form.Control
                              type={fields[field]["type"]}
                              name={fields[field]["name"]}
                              placeholder={`Enter ${fields[field]["label"].toLowerCase()}`}
                              value={data[field] || values[field] || ""}
                              onChange={(e) => handleChange(e, field)}
                              isInvalid={!!getFieldError(field)}
                              maxLength={100}
                              className="border-2"
                            />
                            {getFieldError(field) && (
                              <Form.Control.Feedback type="invalid" className="d-block">
                                {getFieldError(field)}
                              </Form.Control.Feedback>
                            )}
                          </>
                        )}
                      </Form.Group>
                    </div>
                  ))}
              </div>
              
              <div >
                <Button 
                  type="submit" 
                  className="fw-bold" 
                  variant="primary"
                >
                  {!isUpdate ? "Create" : "Update"} &raquo;
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddFacilitation;